<template>
  <div class="molded-seat-step-three">

    <div v-if="form.idc_cover">
      <v-layout>
        <v-switch v-model="form.idc_cover" hide-details label="Housses :" class="title mt-0"
          @change="clearCoverFields" />
        <v-radio-group v-model="form.cover_type" class="mt-2 ml-8" hide-details row :disabled="!form.idc_cover">
          <v-radio class="mt-0" label="Pression" value="PRESSURE" />
          <v-radio class="mt-0" label="Crochet" value="HOOK" />
        </v-radio-group>
      </v-layout>

      <v-radio-group v-model="form.cover_color_type" class="mt-2" hide-details row :disabled="!form.idc_cover">
        <v-radio label="Housses Stretch - Oxygene" value="STRETCH" style="font-size: 12px" />
        <v-radio v-if="form.type == 'RIGID'" label="Housses Vagues" value="WAVE" style="font-size: 12px" />
        <v-radio v-if="form.type == 'RIGID'" label="Housses Alcantara" value="ALCANTARA" style="font-size: 12px" />
        <v-radio v-if="form.type == 'RIGID'" label="Housses 3D" value="3D" style="font-size: 12px" />
      </v-radio-group>

      <div class="cadre mt-3 mb-15">
        <h3 class="mb-0">
          Zone Option
        </h3>

        <v-layout v-if="form.cover_color_type === 'ALCANTARA'" class="color-select">
          <v-select v-model="form.alcantara_id" :items="alcantaraColors" item-text="label" item-value="id"
            class="mb-3 mt-2" hide-details label="Couleur" filled clearable :disabled="!form.idc_cover" />
          <template v-if="previewAlcantaraColor">
            <v-flex v-if="previewAlcantaraColor.texture == 'TEXTURE'" class="preview" style="width: 35px; height: 35px">
              <img :src="previewAlcantaraColor.image" style="width: 100%; height:100%">
            </v-flex>
            <v-flex v-else-if="previewAlcantaraColor.texture == 'COLOR'" class="preview" :style="{
              'background-color': '#' + previewAlcantaraColor.rgb_code
            }" />
          </template>
        </v-layout>

        <v-layout v-if="form.cover_color_type === '3D'" class="color-select">
          <v-select v-model="form.three_d_id" :items="threeDColors" item-text="label" item-value="id" class="mb-3 mt-2"
            hide-details label="Couleur" filled clearable :disabled="!form.idc_cover" />
          <template v-if="preview3DColor">
            <v-flex v-if="preview3DColor.texture == 'TEXTURE'" class="preview" style="width: 35px; height: 35px">
              <img :src="preview3DColor.image" style="width: 100%; height:100%">
            </v-flex>
            <v-flex v-else-if="preview3DColor.texture == 'COLOR'" class="preview"
              :style="{ 'background-color': '#' + preview3DColor.rgb_code }" />
          </template>
        </v-layout>

        <div v-if="form.cover_color_type == 'WAVE'" class="prev-table">
          <v-switch class="mt-0" hide-details label="Prévisualisation" :disabled="!form.idc_cover" />
          <v-simple-table class="mb-3">
            <thead>
              <tr>
                <th class="text-center" />
                <th class="text-center">
                  HOUSE 1
                </th>
                <th class="text-center">
                  HOUSE 2
                </th>
                <th class="text-center">
                  HOUSE 3
                </th>
                <th class="text-center">
                  HOUSE 4
                </th>
                <th class="text-center">
                  HS1
                </th>
                <th class="text-center">
                  HS2
                </th>
                <th class="text-center">
                  HS3
                </th>
                <th class="text-center">
                  HS4
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>INTER</th>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.wave_intern_cover_id1" :items="stretchColors" item-text="label"
                      item-value="id" label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.wave_intern_cover_id2" :items="stretchColors" item-text="label"
                      item-value="id" label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-select v-model="form.wave_intern_cover_id3" :items="stretchColors" item-text="label"
                    item-value="id" label filled clearable hide-details :disabled="!form.idc_cover" />
                </td>
                <td>
                  <v-select v-model="form.wave_intern_cover_id4" :items="stretchColors" item-text="label"
                    item-value="id" label filled clearable hide-details :disabled="!form.idc_cover" />
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.wave_intern_hs_id1" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.wave_intern_hs_id2" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.wave_intern_hs_id3" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.wave_intern_hs_id4" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
              </tr>

              <tr>
                <th>EXTER</th>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.wave_extern_cover_id1" :items="stretchColors" item-text="label"
                      item-value="id" label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.wave_extern_cover_id2" :items="stretchColors" item-text="label"
                      item-value="id" label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-select v-model="form.wave_extern_cover_id3" :items="stretchColors" item-text="label"
                    item-value="id" label filled clearable hide-details :disabled="!form.idc_cover" />
                </td>
                <td>
                  <v-select v-model="form.wave_extern_cover_id4" :items="stretchColors" item-text="label"
                    item-value="id" label filled clearable hide-details :disabled="!form.idc_cover" />
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.wave_extern_hs_id1" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.wave_extern_hs_id2" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.wave_extern_hs_id3" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.wave_extern_hs_id4" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>

        <div v-if="
          form.cover_color_type == 'STRETCH' || form.cover_color_type == null
        " class="prev-table">
          <v-switch class="mt-0" hide-details label="Prévisualisation" :disabled="!form.idc_cover" />
          <v-simple-table class="mb-3">
            <thead>
              <tr>
                <th class="text-center" />
                <th class="text-center">
                  HOUSE 1
                </th>
                <th class="text-center">
                  HOUSE 2
                </th>
                <th class="text-center">
                  HOUSE 3
                </th>
                <th class="text-center">
                  HOUSE 4
                </th>
                <th class="text-center">
                  HS1
                </th>
                <th class="text-center">
                  HS2
                </th>
                <th class="text-center">
                  HS3
                </th>
                <th class="text-center">
                  HS4
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>INTER</th>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.intern_cover_id1" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.intern_cover_id2" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-select v-model="form.intern_cover_id3" :items="stretchColors" item-text="label" item-value="id"
                    label filled clearable hide-details :disabled="!form.idc_cover" />
                </td>
                <td>
                  <v-select v-model="form.intern_cover_id4" :items="stretchColors" item-text="label" item-value="id"
                    label filled clearable hide-details :disabled="!form.idc_cover" />
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.intern_hs_id1" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.intern_hs_id2" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.intern_hs_id3" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.intern_hs_id4" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
              </tr>

              <tr>
                <th>EXTER</th>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.extern_cover_id1" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.extern_cover_id2" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-select v-model="form.extern_cover_id3" :items="stretchColors" item-text="label" item-value="id"
                    label filled clearable hide-details :disabled="!form.idc_cover" />
                </td>
                <td>
                  <v-select v-model="form.extern_cover_id4" :items="stretchColors" item-text="label" item-value="id"
                    label filled clearable hide-details :disabled="!form.idc_cover" />
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.extern_hs_id1" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.extern_hs_id2" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.extern_hs_id3" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
                <td>
                  <v-layout align-center>
                    <v-select v-model="form.extern_hs_id4" :items="stretchColors" item-text="label" item-value="id"
                      label filled clearable hide-details :disabled="!form.idc_cover" />
                  </v-layout>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </div>
    </div>

    <HousseComplexe :form="form" />

    <v-layout>
      <v-switch
        v-model="form.is_attachments_enabled"
        hide-details
        label="Fixations :"
        class="mb-4 title"
      />
    </v-layout>

    <AttachmentsTable
      :config="attachmentsConfig"
      :form="form"
      :dropdowns="dropdowns"
      :disabled="!form.is_attachments_enabled"
    />

    <v-textarea class="mt-4" v-model="form.mounting_comment" filled name="Ajouter un commentaire :"
      label="Ajouter un commentaire :" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import HousseComplexe from "../../modules/HousseComplexe.vue";
import { OTN_FORM_CONFIG } from "@/config/forms/otn-config";
import AttachmentsTable from "@/components/forms/advanced/AttachmentsTable.vue";

export default {
  name: "MoldedSeatStepThree",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true,
    },
  },

  components: {
    HousseComplexe,
    AttachmentsTable,
  },

  data() {
    return {
      attachmentsConfig: OTN_FORM_CONFIG.steps[0].sections[0].config
    };
  },

  computed: {
    ...mapGetters({
      stretchColors: "colors/getSTRETCHType",
      alcantaraColors: "colors/getALCANTARAType",
      threeDColors: "colors/get3DType",

      dropdowns: "dropdowns/getMoldedSeatOptions",
    }),

    previewAlcantaraColor() {
      return this.alcantaraColors.find(
        (color) => color.id == this.form.alcantara_id
      );
    },

    preview3DColor() {
      return this.threeDColors.find(
        (color) => color.id == this.form.three_d_id
      );
    },

    previewWavesColor() {
      return this.stretchColors.find((color) => color.id == this.form.waves_id);
    },
  },

  created() {
    this.$validator = this.parentValidator;
  },

  methods: {
    ...mapActions({
      getDropdownsByProduct: "dropdowns/getLocalDropdownsByProduct",
      getColors: "colors/getAllColors",
    }),

    // Clear cover fields
    clearCoverFields(all = true) {
      if (all) {
        this.form.cover_color_type = null;
      }

      this.form.cover_type = null;
      this.form.intern_cover_id1 = null;
      this.form.intern_cover_id2 = null;
      this.form.intern_cover_id3 = null;
      this.form.intern_cover_id4 = null;
      this.form.intern_hs_id1 = null;
      this.form.intern_hs_id2 = null;
      this.form.intern_hs_id3 = null;
      this.form.intern_hs_id4 = null;
      this.form.extern_cover_id1 = null;
      this.form.extern_cover_id2 = null;
      this.form.extern_cover_id3 = null;
      this.form.extern_cover_id4 = null;
      this.form.extern_hs_id1 = null;
      this.form.extern_hs_id2 = null;
      this.form.extern_hs_id3 = null;
      this.form.extern_hs_id4 = null;
      this.form.wave_intern_cover_id1 = null;
      this.form.wave_intern_cover_id2 = null;
      this.form.wave_intern_cover_id3 = null;
      this.form.wave_intern_cover_id4 = null;
      this.form.wave_intern_hs_id1 = null;
      this.form.wave_intern_hs_id2 = null;
      this.form.wave_intern_hs_id3 = null;
      this.form.wave_intern_hs_id4 = null;
      this.form.wave_extern_cover_id1 = null;
      this.form.wave_extern_cover_id2 = null;
      this.form.wave_extern_cover_id3 = null;
      this.form.wave_extern_cover_id4 = null;
      this.form.wave_extern_hs_id1 = null;
      this.form.wave_extern_hs_id2 = null;
      this.form.wave_extern_hs_id3 = null;
      this.form.wave_extern_hs_id4 = null;
      this.form.alcantara_id = null;
      this.form.three_d_id = null;
    },
  },
};
</script>

<style>
.cadre {
  background-color: rgb(235, 245, 245);
  height: 200px;
  padding: 10px;
  border-radius: 4px;
}
</style>
